// extracted by mini-css-extract-plugin
module.exports = {"Btn":"Tab_Btn__2sQwE","active":"Tab_active__RlOUI"};